"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var model = {
    MODEL: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment Model on Model {\n      code\n      attributes {\n        oemcode\n        shortname\n        modelyear\n        brand\n        label\n        fullSpecsUrl\n        longdescription\n      }\n    }\n  "], ["\n    fragment Model on Model {\n      code\n      attributes {\n        oemcode\n        shortname\n        modelyear\n        brand\n        label\n        fullSpecsUrl\n        longdescription\n      }\n    }\n  "]))),
};
exports.default = model;
var templateObject_1;
